import style from "../../style/Debt.module.scss";
import className from "classnames/bind";
import {useState, useEffect} from "react";
import {Row} from "antd";
import _ from "lodash";
import ActionBar from "~/layout/ActionBar";
import {
    Loading,
    Icon,
} from "~/components";
import {
    apiError,
    handleRequest,
    numberFormat
} from "~/utils";
import {
    reportApi,
    contractApi
} from "~/api";
import DebtTable from "../../components/debt/DebtTable";
import DebtSearchBar from "../../components/debt/DebtSearch";
import {useGroup} from "../../../../hooks";

const cn = className.bind(style);

function DebtReport() {

    const listGroup = useGroup();

    const [loading, setLoading] = useState(false);
    
    const [loadingDetail, setLoadingDetail] = useState(false);

    const [filter, setFilter] = useState({
        success: false,
        detail: ['user']
    });

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 20,
        total: 0
    });

    const [reportData, setReportData] = useState([]);
    
    const [reportContract, setReportContract] = useState([]);

    const handleLoad = async () =>
    {
        setLoading(true);
        let [error, response] = await handleRequest(reportApi.debt(filter));
        let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);
        if (!message)
        {
            setReportData(response.data)
        }
        setLoading(false);
    }

    //Load data
    useEffect(() => {
        handleLoad().then();
    }, [filter]);


    const handleLoadDetail = async () =>
    {
        setLoadingDetail(true);

        let [error, response] = await handleRequest(contractApi.gets({
            ...filter,
            status: 'not-cancel',
            page: pagination.page,
            limit: pagination.limit,
        }));

        let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);

        if (!message)
        {
            setReportContract(response.data)

            setPagination({
                page: pagination.page,
                limit: pagination.limit,
                total: response.pagination.total,
            })
        }

        setLoadingDetail(false);
    }

    useEffect(() => {
        handleLoadDetail().then();
    }, [filter, pagination.page]);

    //Search
    const handleFilterChange = (key, value) =>
    {
        setFilter({
            ...filter,
            [key]: value
        });

        setPagination({
            page: 1,
            limit: pagination.limit,
            total: pagination.total,
        });
    };

    const handlePaginationChange = (page) => {
        setPagination({
            page: page,
            limit: pagination.limit,
            total: pagination.total,
        });
    }

    return (
        <>
            <ActionBar title={'Công nợ'}></ActionBar>
            <div className="container d-block">
                <div className="content pd-1" style={{overflow:'auto'}}>
                    {
                        loading && <Loading noFixed spin={true} />
                    }
                    {
                        !loading && <Row gutter={10}>
                            <div className={cn('item-gird')}>
                                <div className={cn('item', 'item-red')}>
                                    <div className={cn('icon')}>{Icon.plusCircle}</div>
                                    <div className={cn('info')}>
                                        <h3>Tổng</h3>
                                        <p>{numberFormat(reportData.total)}</p>
                                        <p className={cn('mini')}>{numberFormat(reportData.count)} hợp đồng</p>
                                    </div>
                                </div>
                                {
                                    !_.isEmpty(reportData?.services) && reportData?.services.map((item) => {
                                        return (
                                            <div key={item.key} className={cn('item', 'item-'+item.badge)}>
                                                <div className={cn('icon')}>{Icon.plusCircle}</div>
                                                <div className={cn('info')}>
                                                    <h3>{item.name}</h3>
                                                    <p>{numberFormat(item.total)}</p>
                                                    <p className={cn('mini')}>{numberFormat(item.count)} hợp đồng</p>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Row>
                    }
                </div>
                <div className="content pd-1" style={{overflow:'auto'}}>
                    <DebtSearchBar filter={filter} listGroup={listGroup} onChange={handleFilterChange}/>
                    {
                        loadingDetail && <Loading noFixed spin={true} />
                    }
                    {
                        !loadingDetail && <DebtTable
                            items={reportContract}
                            pagination={pagination}
                            onPaginationChange={handlePaginationChange}
                            filter={filter}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default DebtReport;